import { render, staticRenderFns } from "./pos-retail-new.vue?vue&type=template&id=7df62085"
import script from "./pos-retail-new.vue?vue&type=script&lang=js"
export * from "./pos-retail-new.vue?vue&type=script&lang=js"
import style0 from "./pos-retail-new.vue?vue&type=style&index=0&id=7df62085&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports